import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import checkoutTrend from '../assets/checkout_trend.png';
import loanTrend from '../assets/loan_trend.png';

const LaptopStatisticsPage = () => {
  return (
    <div>
      <Container className="mt-5">
        <Row className="mb-5 justify-content-center">
          <Col md={8} xs={12}>
            <h5 className="text-center mb-3">Checkout Trend</h5>
            <Image src={checkoutTrend} alt="Checkout Trend" fluid rounded className="shadow-sm" />
          </Col>
        </Row>

        <Row className="mb-5 justify-content-center">
          <Col md={8} xs={12}>
            <h5 className="text-center mb-3">Loan Trend</h5>
            <Image src={loanTrend} alt="Loan Trend" fluid rounded className="shadow-sm" />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LaptopStatisticsPage;
